import { Cpu, CheckCircle2, XCircle, Clock, Loader2 } from 'lucide-react';

const STATUS_CONFIG = {
  completed: { icon: CheckCircle2, color: 'text-green-600', bg: 'bg-green-100' },
  failed: { icon: XCircle, color: 'text-red-600', bg: 'bg-red-100' },
  running: { icon: Loader2, color: 'text-amber-600', bg: 'bg-amber-100', spin: true },
  pending: { icon: Clock, color: 'text-muted-foreground', bg: 'bg-muted' },
};

export default function AgentTasksTab({ tasks, onRefresh }) {
  return (
    <div className="space-y-4" data-testid="agent-tasks-tab">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">{tasks.length} agent task(s)</p>
        <button onClick={onRefresh} className="text-xs text-primary hover:underline" data-testid="refresh-tasks-btn">Refresh</button>
      </div>

      {tasks.length === 0 ? (
        <div className="bg-white rounded-xl border border-border p-8 text-center">
          <Cpu className="w-8 h-8 text-muted-foreground mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">No agent tasks yet. Trigger research from the Products, Installers, or Marketing tabs.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {tasks.map(t => {
            const cfg = STATUS_CONFIG[t.status] || STATUS_CONFIG.pending;
            const Icon = cfg.icon;
            return (
              <div key={t.task_id} className="bg-white rounded-xl border border-border p-4 shadow-sm" data-testid={`task-${t.task_id}`}>
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-3">
                    <div className={`w-8 h-8 rounded-full ${cfg.bg} flex items-center justify-center`}>
                      <Icon className={`w-4 h-4 ${cfg.color} ${cfg.spin ? 'animate-spin' : ''}`} />
                    </div>
                    <div>
                      <p className="text-sm font-medium">{t.type.replace(/_/g, ' ')}</p>
                      <p className="text-xs text-muted-foreground">
                        {Object.entries(t.params || {}).map(([k, v]) => `${k}: ${v}`).join(' · ')}
                      </p>
                    </div>
                  </div>
                  <span className={`text-xs px-2 py-0.5 rounded-full ${cfg.bg} ${cfg.color}`}>{t.status}</span>
                </div>
                {t.result && (
                  <p className="text-xs text-muted-foreground mt-2 pl-11">{JSON.stringify(t.result)}</p>
                )}
                {t.error && (
                  <p className="text-xs text-red-600 mt-2 pl-11">{t.error}</p>
                )}
                <p className="text-xs text-muted-foreground mt-1 pl-11">{new Date(t.created_at).toLocaleString()}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
